import { useEffect, useState } from "react";
import { X } from "lucide-react";

const KEY = "bl_cookie_consent_v1";

export default function CookieConsent() {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (!localStorage.getItem(KEY)) {
            const t = setTimeout(() => setOpen(true), 800);
            return () => clearTimeout(t);
        }
    }, []);

    // While the banner is visible, reserve space at the bottom of the
    // document so content (e.g. the Annual Members Receive panel on
    // /pricing) never sits underneath the banner on mobile.
    useEffect(() => {
        if (!open) {
            document.body.classList.remove("has-cookie-banner");
            return;
        }
        document.body.classList.add("has-cookie-banner");
        return () => document.body.classList.remove("has-cookie-banner");
    }, [open]);

    const decide = (val) => {
        localStorage.setItem(KEY, val);
        setOpen(false);
    };

    if (!open) return null;

    return (
        <div
            className="fixed z-50 bottom-4 left-4 right-4 md:bottom-6 md:left-auto md:right-6 md:max-w-md"
            data-testid="cookie-consent"
        >
            <div className="bl-card p-5 shadow-[0_20px_50px_rgba(15,35,38,0.15)]">
                <div className="flex items-start justify-between gap-3">
                    <div>
                        <div className="text-[10px] tracking-[0.2em] uppercase text-bl-muted">
                            Cookies
                        </div>
                        <h3 className="mt-1 font-display font-medium text-bl">
                            We use minimal cookies.
                        </h3>
                    </div>
                    <button
                        onClick={() => decide("dismissed")}
                        className="text-bl-muted"
                        aria-label="Close"
                    >
                        <X className="w-4 h-4" />
                    </button>
                </div>
                <p className="mt-2 text-sm text-bl-muted leading-relaxed">
                    Authentication cookies are required. Optional analytics help us
                    improve the product.
                </p>
                <div className="mt-4 flex gap-2 flex-wrap">
                    <button
                        onClick={() => decide("accept_all")}
                        className="bl-btn-primary text-sm"
                        data-testid="cookie-accept-btn"
                    >
                        Accept all
                    </button>
                    <button
                        onClick={() => decide("reject_non_essential")}
                        className="bl-btn-secondary text-sm"
                        data-testid="cookie-reject-btn"
                    >
                        Reject non-essential
                    </button>
                </div>
            </div>
        </div>
    );
}
